export const SAVED_KEY = 'ennix_saved_later';
export const QTY_OPTIONS = Array.from({ length: 10 }, (_, i) => ({ label: String(i + 1), value: i + 1 }));

export const getSaved = () => {
    if (typeof window === 'undefined') return [];
    try { return JSON.parse(localStorage.getItem(SAVED_KEY) || '[]'); } catch { return []; }
};

export const persistSaved = (items) => {
    if (typeof window !== 'undefined') localStorage.setItem(SAVED_KEY, JSON.stringify(items));
};

export const getAuthUser = () => {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(/(?:^|; )authUser=([^;]*)/);
    if (!match) return null;
    try { return JSON.parse(decodeURIComponent(match[1])); } catch { return null; }
};

export const normalizeItems = (raw) => {
    if (!Array.isArray(raw)) return [];
    return raw.map((item) => ({
        _id: item._id,
        productId:  item.productId  ?? item._id          ?? item.product?._id,
        categoryId: item.categoryId ?? item.product?.categoryId ?? null,
        title:      item.productTitle ?? item.title      ?? item.product?.title,
        price:      item.price        ?? item.product?.price ?? 0,
        mrp:        item.mrp          ?? item.product?.mrp   ?? null,
        coverImage: item.productImage ?? item.coverImage ?? item.product?.coverImage,
        slug:       item.productSlug  ?? item.slug       ?? item.product?.slug,
        quantity:   item.quantity ?? 1,
        shippingCharges: item.shippingCharges ?? item.product?.shippingCharges ?? 0,
        outOfStock: item.outOfStock ?? false,
        warranty:   item.warranty ?? item.product?.warranty ?? null,
    }));
};

export const calcDiscount = (price, mrp) => {
    if (!mrp || mrp <= price) return { discount: 0, discountPct: 0 };
    const discount = mrp - price;
    const discountPct = Math.round((discount / mrp) * 100);
    return { discount, discountPct };
};
